// extracted by mini-css-extract-plugin
module.exports = {"barColor":"#29abe0","barActiveColor":"#f39e39","freqSelected":"#eb744f"};